module.exports = __webpack_public_path__ + "img/electronics.300f3e69.jpg";